export class FundQuotaOperationValueUpdate {
  operationValue: number = null;
  oldOperationValue: number = null;
}
